import React from 'react';
import { PhoneCallIcon, AlertCircleIcon, CalendarIcon, MessageSquareIcon } from 'lucide-react';
export function MobileBottomBar() {
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#588157] text-white border-t border-white/10 px-4 py-2 pb-safe" data-id="element-66">
      <div className="flex justify-around items-center max-w-md mx-auto" data-id="element-67">
        <a href="tel:911" className="flex flex-col items-center gap-1 p-2 text-[#F8F9FA]" data-id="element-68">
          <AlertCircleIcon size={20} className="text-red-400" data-id="element-69" />
          <span className="text-[10px] font-medium uppercase tracking-tighter" data-id="element-70">
            Emergency
          </span>
        </a>
        <a href="#" className="flex flex-col items-center gap-1 p-2 text-[#F8F9FA]" data-id="element-71">
          <PhoneCallIcon size={20} data-id="element-72" />
          <span className="text-[10px] font-medium uppercase tracking-tighter" data-id="element-73">
            Critical Care
          </span>
        </a>
        <div className="relative -top-6" data-id="element-74">
          <button className="w-14 h-14 bg-[#D4A373] rounded-full flex items-center justify-center shadow-lg border-4 border-[#588157]" data-id="element-75">
            <CalendarIcon size={24} data-id="element-76" />
          </button>
        </div>
        <a href="#" className="flex flex-col items-center gap-1 p-2 text-[#F8F9FA]" data-id="element-77">
          <MessageSquareIcon size={20} data-id="element-78" />
          <span className="text-[10px] font-medium uppercase tracking-tighter" data-id="element-79">
            Portal
          </span>
        </a>
        <a href="#" className="flex flex-col items-center gap-1 p-2 text-[#F8F9FA]" data-id="element-80">
          <CalendarIcon size={20} data-id="element-81" />
          <span className="text-[10px] font-medium uppercase tracking-tighter" data-id="element-82">
            Schedule
          </span>
        </a>
      </div>
    </div>;
}